import * as mailTemplateEdit from '../services/mailTemplateEdit';

//生成唯一id
function guid() {
  return Number(Math.random().toString().substr(3, 3) + Date.now()).toString(
    36,
  );
}
export default {
  namespace: 'mailTemplateEdit',
  state: {
    templateInfo: null,
  },
  effects: {
    *addMailTemplate({ payload: { values }, callback }, { call }) {
      const fileList =
        values?.fileList?.length > 0
          ? values.fileList.map((item) => ({
              fileName: item.fileName,
              filePath: item?.filePath,
              fileUrl: item.fileUrl,
            }))
          : null;
      const filterValue = { ...values, fileList };
      const response = yield call(
        mailTemplateEdit.addMailTemplate,
        filterValue,
      );
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    *getQueryMailTemplate({ payload: { values } }, { call, put }) {
      const response = yield call(
        mailTemplateEdit.getQueryMailTemplate,
        values,
      );

      const data = response.data;
      for (let v in data) {
        if (v === 'fileList') {
          data[v] = data[v]?.map((item) => ({ ...item, id: guid() }));
          break;
        }
      }
      yield put({
        type: 'save',
        payload: {
          templateInfo: data,
        },
      });
    },
    *updateMailTemplate({ payload: { values }, callback }, { call }) {
      const fileList =
        values?.fileList?.length > 0
          ? values.fileList.map((item) => ({
              fileName: item.fileName,
              filePath: item?.filePath,
              fileUrl: item.fileUrl,
            }))
          : null;
      const filterValue = { ...values, fileList };
      const response = yield call(
        mailTemplateEdit.updateMailTemplate,
        filterValue,
      );
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
  },

  reducers: {
    save(state, action) {
      return { ...state, ...action.payload };
    },
  },
  subscriptions: {
    setup({ history, dispatch }) {
      return history.listen((props) => {
        if (
          props.pathname === '/mail/mail_template/mail_template_edit' ||
          props.pathname === '/mail/mail_template/mail_template_add' ||
          props.pathname === '/mail/mail_template/mail_template_detail'
        ) {
          dispatch({
            type: 'save',
            payload: {
              templateInfo: null,
            },
          });
        }
      });
    },
  },
};
